import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiForumPostViewComponent } from './fi-forum-post-view.component';
import { FiForumPostViewContainerComponent } from './fi-forum-post-view-container.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCardModule } from '@angular/material/card';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiCommentsListModule } from '@fi-shared/fi-comments/fi-comments-list/fi-comments-list.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiLikesModule } from '@fi-shared/fi-likes/fi-likes.module';
import { MatButtonModule } from '@angular/material/button';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FiForumPostEditModule } from '@fi-shared/fi-forum/fi-forum-post-edit/fi-forum-post-edit.module';
import { FiButtonBackNewModule } from '@fi-shared/fi-button-back-new/fi-button-back-new.module';
import { FiCommentLikeButtonsModule } from '@fi-shared/fi-comments/fi-comment-like-buttons/fi-comment-like-buttons.module';
import { FiReadsCountButtonModule } from '@fi-shared/fi-news-feed-shared/fi-news-feed-buttons/fi-reads-count-button/fi-reads-count-button.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        MatCardModule,
        FiProfileIconModule,
        FiFormatDateModule,
        FiCommentsListModule,
        FiBindHtmlCompileModule,
        FiLikesModule,
        MatButtonModule,
        FiAttachmentsModule,
        MatIconModule,
        MatMenuModule,
        FiForumPostEditModule,
        FiButtonBackNewModule,
        FiCommentLikeButtonsModule,
        FiReadsCountButtonModule,
    ],
    declarations: [FiForumPostViewComponent, FiForumPostViewContainerComponent],
    exports: [FiForumPostViewComponent],
})
export class FiForumPostViewModule {}
